import {
  fetchFieldDefinitions,
  addSelectedColumn,
  removeSelectedColumn,
  removeAllSelectedColumn,
  reorderColumns,
  updateTableColumnDefinition,
  saveSelectedColumns,
} from '../routines';

import {
  ENTITY_CONTACT,
  ENTITY_PROFILE,
  ORGANIZATION,
  ACCOUNT,
  CONTACT,
  PRODUCT,
  PIPELINE,
} from '../../common/constants/TableColumnScopeConstants';

const initialAttributes = {
  definitions: {},
  definitionsLoading: false,
  columnReOrderLoading: false,
  selected: [],
  unselected: [],
};

const initialState = {
  [ORGANIZATION]: { ...initialAttributes },
  [ACCOUNT]: { ...initialAttributes },
  [CONTACT]: { ...initialAttributes },
  [PIPELINE]: { ...initialAttributes },
  [PRODUCT]: { ...initialAttributes },
  [ENTITY_CONTACT]: { ...initialAttributes },
  [ENTITY_PROFILE]: { ...initialAttributes },
};

const exampleReducer = (state = initialState, action) => {
  switch (action.type) {
    case reorderColumns.TRIGGER:
    case addSelectedColumn.TRIGGER:
    case removeSelectedColumn.TRIGGER:
    case removeAllSelectedColumn.TRIGGER: {
      const { scope } = action.payload;
      return {
        ...state,
        [scope]: {
          ...state[scope],
          columnReOrderLoading: true,
        },
      };
    }

    case reorderColumns.SUCCESS: {
      const { scope } = action.payload;
      return {
        ...state,
        [scope]: {
          ...state[scope],
          selected: action.payload.selected,
          columnReOrderLoading: false,
        },
      };
    }
    case addSelectedColumn.SUCCESS:
    case removeSelectedColumn.SUCCESS:
    case removeAllSelectedColumn.SUCCESS: {
      const { scope } = action.payload;
      return {
        ...state,
        [scope]: {
          ...state[scope],
          unselected: action.payload.unselected,
          selected: action.payload.selected,
          columnReOrderLoading: false,
        },
      };
    }

    case reorderColumns.FAILURE:
    case addSelectedColumn.FAILURE:
    case removeSelectedColumn.FAILURE:
    case removeAllSelectedColumn.FAILURE: {
      const { scope } = action.payload;
      return {
        ...state,
        [scope]: {
          ...state[scope],
          columnReOrderLoading: false,
        },
      };
    }

    case saveSelectedColumns.SUCCESS: {
      return state;
    }

    case fetchFieldDefinitions.SUCCESS: {
      const { scope } = action.payload;
      return {
        ...state,
        [scope]: {
          ...state[scope],
          definitions: action.payload.definitions,
          allDefinitions: action.payload.allDefinitions,
          unselected: action.payload.unselected,
          selected: action.payload.selected,
          definitionsLoading: false,
        },
      };
    }
    case fetchFieldDefinitions.TRIGGER: {
      const { scope } = action.payload;
      return {
        ...state,
        [scope]: {
          ...state[scope],
          definitionsLoading: true,
        },
      };
    }
    case updateTableColumnDefinition.TRIGGER: {
      const { scope, definition, data } = action.payload;
      return {
        ...state,
        [scope]: {
          ...state[scope],
          definitions: {
            ...state[scope].definitions,
            [definition]: { ...state[scope].definitions[definition], ...data },
          },
        },
      };
    }
    default:
      return state;
  }
};

export default exampleReducer;
